import * as actions from './actions'
import * as types from './mutation-types'

const state = {
  storeControllerCommandsError: '',
  storeControllerCommandsLoading: false
}

const getters = {
  storeControllerCommandsLoading: state => state.storeControllerCommandsLoading,
  storeControllerCommandsError: state => state.storeControllerCommandsError
}

const mutations = {
  [types.POST_CONTROLLER_COMMANDS_REQUEST] (state){
    state.storeControllerCommandsLoading = true;
    state.storeControllerCommandsError = {};
  },
  [types.POST_CONTROLLER_COMMANDS_SUCCESS] (state){
    state.storeControllerCommandsLoading = false;
    state.storeControllerCommandsError = {};
  },
  [types.POST_CONTROLLER_COMMANDS_FAILURE] (state, error){
    state.storeControllerCommandsLoading = false;
    state.storeControllerCommandsError = error;
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}
